import Vue from 'vue'

Vue.directive('drag', {
  // 当被绑定的元素插入到 DOM 中时……
  bind: el => {
    let odiv = el
    odiv.onmousedown = e => {
      if (e.button !== 0) return
      const translate = odiv.style.transform.match(/translate\((.*?)\)/)
      const ret = translate && translate[1].split(',')
      const ox = ret ? +ret[0].slice(0, -2) : 0
      const oy = ret ? +ret[1].slice(0, -2) : 0
      const x = e.clientX - ox
      const y = e.clientY - oy

      el.onmousemove = evt => {
        //移动当前元素
        odiv.setAttribute(
          'style',
          `transform: translate(${evt.clientX - x}px, ${evt.clientY - y}px)`
        )
      }
      document.onmouseup = () => {
        el.onmousemove = null
        document.onmouseup = null
      }
    }
  }
})
